import http from '@/core/http'

const url = 'expense-configs'

const state = {
  itens: [],
  cadastroExistente: false,
  item: {
    id: '',
    name: '',
    affiliate: '',
    txDeposit: 0,
    txCosts: 0,
    txWithdraw: 0,
    created: ''
  },
  totalItens: 0,
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, {params: { ...payload }})
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },
  cadastrarItem: async (_, payload) => {
    const result = await http.post(url, payload)
    return Promise.resolve(result)
  },
  editarItem: async (_, payload) => {
    const result = await http.put(url, payload)
    return Promise.resolve(result)
  },
  deletarItem: async (_, payload) => {
    const result = await http.delete(url, { params: payload })
    return Promise.resolve(result)
  },
  getItem: async ({ commit, getters }, payload) => {
    const result = await http.get(url, { params: { _addlFilter: { 'ex:id_=': payload.id }} })
    commit('SET_ITEM', { payload: result.data.resultMap[0], getters })
    Promise.resolve(result)
  },
  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },
  setItem: ({ commit }, payload) => {
    commit('SET_ITEM', payload)
  },
  setAffiliate: async ({commit}, payload) => {
    commit('ADD_PARENT_ID_AFFILIATE', payload)
  },
  setCadastroExistente: ({ commit }, payload) => {
    commit('SET_CADASTRO_EXISTENTE', payload)
  }
}

const mutations = {  
  'CLEAR_VALUE_RANGE' (state) {
    state.itemValueRange.aliquot = ''
  },
  'SET_CADASTRO_EXISTENTE' (state, payload) {
    state.cadastroExistente = payload
  },
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },
  'ADD_PARENT_ID_AFFILIATE' (state, payload) {
    state.item.affiliate = payload
  },
  'LISTA_ITEM' (state, { payload }) {
    state.itens = payload.data.resultMap[0]
  },
  'LIMPAR_ITEM' (state) {
    state.item = {
      id: '',
      name: '',
      affiliate: '',
      txDeposit: 0,
      txCosts: 0,
      txWithdraw: 0,
      created: ''
    }
  },
  'SET_ITEM' (state, { payload } ) {
    const item = Object.assign({}, payload)
    state.item = {
      id: item.id,
      name: item.name,
      affiliate: item.affiliate,
      txDeposit: item.txDeposit,
      txCosts: item.txCosts,
      txWithdraw: item.txWithdraw,
      created: item.created
    }
  },
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
  item: state => state.item,
  getCadastroExistente: state => state.cadastroExistente,
}

export default { namespaced: true, state, actions, mutations, getters }